/* client/src/utils/formatters.ts */

export const formatNumber = (value: unknown): number => {
  if (value === null || value === undefined || value === '') return 0;
  
  // Handle boolean values
  if (typeof value === 'boolean') return value ? 1 : 0;
  
  // Handle string values
  if (typeof value === 'string') {
    // Remove any non-numeric characters except decimal point and minus sign
    const numericString = value.replace(/[^\d.-]/g, '');
    const parsed = parseFloat(numericString);
    return isNaN(parsed) ? 0 : parsed;
  }
  
  // Handle number values
  if (typeof value === 'number') return value;
  
  // For other types (objects, arrays, etc.), try to convert to number
  const parsed = Number(value);
  return isNaN(parsed) ? 0 : parsed;
};

export const formatCurrency = (value: unknown): string => {
  const numberValue = formatNumber(value);
  return `د.${numberValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatNumberWithCommas = (value: unknown): string => {
  return formatNumber(value).toLocaleString('en-US');
};

export const formatWeight = (value: unknown, unit: string = 'KG'): string => {
  const numberValue = formatNumber(value);
  return `${numberValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${unit}`;
};

// Additional utility for percentage formatting
export const formatPercentage = (value: unknown): string => {
  const numberValue = formatNumber(value);
  return `${numberValue.toFixed(2)}%`;
};